import { ForumError, forumError, forumEnvelope, invalidResponse, staleResponse } from './forumErrors';
import { forumId, forumUrl } from '../models/forumMappers';

// The editor only sees a verified image descriptor. Session/CSRF and multipart
// boundaries belong to the transport; no replay or cache of uploaded files.
export function createForumUploadRepository({ http, getIdentity }) {
  const identity = () => JSON.stringify(getIdentity() || {});
  return {
    async upload(file, onProgress = () => {}) {
      const expected = identity(), account = getIdentity() || {};
      if (!forumId(account.uid)) throw new ForumError('authentication_required', 'Inicia sesión para subir imágenes.', 401);
      if (!(file instanceof File) || !file.size || file.size > 8 * 1024 * 1024
          || !['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(file.type)) {
        throw new ForumError('invalid_image', 'Elige una imagen JPG, PNG, GIF o WebP de hasta 8 MiB.', 422);
      }
      const data = new FormData(); data.append('image', file);
      try {
        const response = await http.post('/forum/api/v2/images', data, {
          onUploadProgress(event) {
            if (identity() === expected && event.total > 0 && Number.isFinite(event.loaded)) {
              onProgress(Math.min(100, Math.max(0, Math.round(event.loaded / event.total * 100))));
            }
          }
        });
        if (identity() !== expected) throw staleResponse();
        const image = forumEnvelope(response.data).data;
        const id = forumId(image.id), url = forumUrl(image.url);
        if (!id || !url || !Number.isInteger(image.width) || !Number.isInteger(image.height)
            || image.width < 1 || image.height < 1 || image.width > 16000 || image.height > 16000
            || image.width * image.height > 40000000) throw invalidResponse();
        return { id, url, width: image.width, height: image.height, alt: '' };
      } catch (error) {
        if (identity() !== expected) throw staleResponse();
        throw forumError(error);
      }
    }
  };
}
